import {
  CurrencyDisplay,
  LeftRightFlexedContainer,
  ModalSectionTitle,
} from "../../../../components";
import { SubmitButton, TextInput } from "../../../../hook-form";
import { IRefundToCustomerFormViewProps } from "./RefundToCustomerForm";

export const View = ({
  isLoadingFormData,
  isFormEnabled,
  formDisabledReason,

  refundAmount,
  refundCurrency,

  errors,
  handleSubmit,
  register,
}: IRefundToCustomerFormViewProps) => {
  return (
    <form
      onSubmit={handleSubmit}
      className="accept-as-partial--form bordered border-dashed b-r-5 pl-5 pr-5 pb-5"
    >
      <ModalSectionTitle
        key_id={<>Refund the payment directly to the customer.</>}
        value={""}
      />
      <div className="bg-gray-2 mt-5 mb-5 pl-5 pr-5 pb-5 pt-5 b-r-5">
        <span className="text-danger">
          NOTE: You may need to provide the customer refund bank details if it
          was not captured e.g. for transfers <br />
          made from certain bank apps and POS terminals.
          <br />
          <strong>
            NOTE: No app fee will be applied when refunded to customer.
          </strong>
        </span>{" "}
        <br /> The customer should receive the refund in a short while. If it
        fails you may retry.
      </div>

      <LeftRightFlexedContainer
        key_id="Amount To Refund"
        value={
          <CurrencyDisplay
            amount={refundAmount}
            currencyOrSymbol={refundCurrency}
          />
        }
      />

      <TextInput
        name="description"
        label="Description (Optional)"
        placeholder="e.g. The customer had no active payments or invoices."
        infoIconText="This will help you in the future to recall why you performed this action."
        type="text"
        register={register}
        errors={errors}
      />

      {!formDisabledReason || formDisabledReason === "" ? null : (
        <div className="text-danger mt-5">{formDisabledReason}</div>
      )}

      <div className="flex-container submit-button--container">
        <SubmitButton
          // size="md"
          className="mt-5 flex-box"
          showChildrenWithLoadingIcon
          disabled={!isFormEnabled}
          title={isFormEnabled ? "" : formDisabledReason}
        >
          Refund to customer
        </SubmitButton>
      </div>
    </form>
  );
};
